import {getFullUrlFromRelative} from "./GetFullUrlFromRelative";
import {ProjectInformation} from "./state-slices/state-management/definitions/ProjectInformation";

export function formatFrameUrl(frame: number, urlTemplate: string, currentProject: ProjectInformation) {
    const path = urlTemplate.replace('%d', frame.toString());
    return getFullUrlFromRelative(path, currentProject);
}
